import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import { Button, Container, Icon, Stack, Typography } from "@mui/material";
import type React from "react";

export interface ErrorPageProps {
  /**
   * Der Titel, der auf der Fehlerseite angezeigt wird.
   * @default 'Etwas ist schiefgelaufen'
   */
  title?: string;
  /**
   * Eine detaillierte Meldung über den Fehler.
   */
  message?: string;
  /**
   * Callback für einen "Erneut versuchen" Button.
   * Wenn nicht angegeben, wird die Seite neu geladen.
   */
  onRetry?: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title = "Etwas ist schiefgelaufen",
  message,
  onRetry,
}) => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Stack alignItems="center" justifyContent="center" minHeight="60vh">
        <Icon color="error" sx={{ fontSize: 60, mb: 2 }}>
          <ErrorOutlineIcon fontSize="inherit" />
        </Icon>
        <Typography variant="h3" component="h1" gutterBottom>
          {title}
        </Typography>
        {message && (
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            {message}
          </Typography>
        )}
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Unser Team wurde über den Fehler informiert und wird sich darum
          kümmern.
        </Typography>
        <Button
          variant="contained"
          onClick={onRetry ?? (() => window.location.reload())}
        >
          {onRetry ? "Erneut versuchen" : "Seite neu laden"}
        </Button>
      </Stack>
    </Container>
  );
};
